
import { initializeApp, getApps, getApp, FirebaseApp } from "firebase/app";
import { getAuth, indexedDBLocalPersistence, initializeAuth } from "firebase/auth";
import { Capacitor } from '@capacitor/core';

const firebaseConfig = {
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
};

const whichAuth = (app: FirebaseApp) => {
  let auth;
  if (Capacitor.isNativePlatform()) {
    auth = initializeAuth(app, {
      persistence: indexedDBLocalPersistence
    })
  } else {
    auth = getAuth(app)
  }
  return auth
}

// Validate that required environment variables are present
const requiredEnvVars = [
  'VITE_FIREBASE_PROJECT_ID',
  'VITE_FIREBASE_APP_ID',
  'VITE_FIREBASE_API_KEY',
  'VITE_FIREBASE_AUTH_DOMAIN',
];

const missingEnvVars = requiredEnvVars.filter(envVar => !import.meta.env[envVar]);

if (missingEnvVars.length > 0) {
  throw new Error(
    `Missing required Firebase environment variables: ${missingEnvVars.join(', ')}\n` +
    'Please create a .env.local file with the required Firebase configuration variables.'
  );
}

import { getFirestore } from "firebase/firestore";

// ... existing code ...

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const auth = whichAuth(app);
const db = getFirestore(app);

// Configure action URL for email verification and password reset
// This will redirect users to our app after they complete the action
const actionCodeSettings = {
  url: `${window.location.origin}/`,
  handleCodeInApp: true,
  // Ensure the action code is passed as a query parameter
  dynamicLinkDomain: undefined,
};

// Export actionCodeSettings for use in password reset and email verification
export { app, auth, db, actionCodeSettings };
